import {useTranslation} from "next-i18next";
import Link from "next/link";
import React from "react";
import IconMail from "../../../data/Icons/leon-inmobiliaria-icons-e-mail.svg";
import IconPhone from "../../../data/Icons/leon-inmobiliaria-icons-phone.svg";
import IconWhatsapp from "../../../data/Icons/leon-inmobiliaria-icons-whatsapp.svg";

interface SocialMediaButtonGroupProps {
	source: "contact_rent" | "contact_sale";
}

function SocialMediaButtonGroup({source}: SocialMediaButtonGroupProps) {
	const {t} = useTranslation();

	const whatsappLink = `https://wa.me/${t("consts.contact.whatsapp").replace("+", "").replaceAll(" ", "")}`
	return (
		<div className="flex flex-row items-center justify-around gap-6 xl:gap-12">
			<Link
				href={"/kontakt?source=" + source}
				className="flex items-center justify-between gap-2 xl:gap-4"
			>
				<div className="w-[24px] h-[24px] text-black">
					<IconMail/>
				</div>
				<p className="text-black text-[16px] xl:text-[18px] font-light mt-0">{t("common.email")}</p>
			</Link>
			<Link
				href={whatsappLink}
				onClick={(e) => {
					e.preventDefault();
					window.open(whatsappLink, "_blank");
				}}
				className="flex items-center justify-between gap-2 xl:gap-4"
			>
				<div className="w-[24px] h-[24px] text-black">
					<IconWhatsapp/>
				</div>
				<p className="text-black text-[16px] xl:text-[18px] font-light mt-0">{t("common.whatsapp")}</p>
			</Link>
			<Link
				href={`tel:${t("consts.contact.tel").replaceAll(" ", "")}`}
				className="flex items-center justify-between gap-2 xl:gap-4"
			>
				<div className="w-[24px] h-[24px] text-black">
					<IconPhone/>
				</div>
				<p className="text-black text-[16px] xl:text-[18px] font-light mt-0">{t("common.phone")}</p>
			</Link>
		</div>
	);
}

export default SocialMediaButtonGroup;
